export const DEV = process.env.NODE_ENV === "development";
export default {
  DEV,
  enableLoginForm: false,
  basename: DEV ? null : '/',
  baseUrl: 'https://cte.med.cuhk.edu.hk/api',
  logoutUrl: 'https://cte.med.cuhk.edu.hk/api/one-pass/logout',
  publicUrl: 'https://cte.med.cuhk.edu.hk',
};
